module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/promotion_empty-147f3fda6b484856ba63893274d60fa8.png";